import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-column-header-item',
    template: '',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ColumnHeaderItemComponent
{
    @Input() labelKey: string;
    @Input() sorterKey: string;
    @Input() class: string;
    @Input() active: boolean = false;
    @Input() sortable: boolean = true;
}
